const todoList = [{
    id:'td0',
    cont: '제목에 키워드가 들어갔다.',
    onOff: false
},{
    id:'td1',
    cont: '본문에 키워드가 2회 이상 들어갔다.',
    onOff: false
},{
    id:'td2',
    cont: '이미지가 2개 이상 들어갔다.',
    onOff: false
},{
    id:'td3',
    cont: '링크가 2개 이상 들어갔다.',
    onOff: false
},{
    id:'td4',
    cont: '본문에 소제목이 2개 이상 들어갔다.',
    onOff: false
},{
    id:'td5',
    cont: '글자수 공백 제외 1500자 이상.',
    onOff: false
},{
    id:'td6',
    cont: '태그가 1개 이상 들어갔다.',
    onOff: false
}];

export default todoList;